import { isNil, sum, pluck, values, uniq, length, filter } from 'ramda';
import { isBlank } from 'utils/helperMethods';
import Presenter from 'utils/PropTypesPresenter';
import MessagePresenter from 'presenters/MessagePresenter';
import FirebaseChatPresenter from 'presenters/FirebaseChatPresenter';

const MIN_BIDS = 2;
const MIN_UNIQ_ACTIVITY_DAYS = 4;

export default new Presenter(
  {},
  {
    sortedByNewestMessage(chats) {
      return chats.sort(({ latestMessage: firstMessage }, { latestMessage: secondMessage }) => {
        const firstMessageCreatedAt = isBlank(firstMessage) ? null : MessagePresenter.createdAt(firstMessage);
        const secondMessageCreatedAt = isBlank(secondMessage) ? null : MessagePresenter.createdAt(secondMessage);

        if (isNil(firstMessageCreatedAt) && isNil(secondMessageCreatedAt)) return 0;
        if (isNil(firstMessageCreatedAt)) return 1;
        if (isNil(secondMessageCreatedAt)) return -1;

        return secondMessageCreatedAt - firstMessageCreatedAt;
      });
    },
    unreadCount(chats) {
      if (isBlank(chats)) return 0;
      return sum(pluck('unreadCount', chats).filter(chat => typeof chat === 'number'));
    },
    withTasks(chats) {
      return filter(chat => {
        const latestMessage = FirebaseChatPresenter.latestMessage(chat);
        const isSentToday = MessagePresenter.isSentToday(latestMessage);
        const bidsCount = FirebaseChatPresenter.bidsCount(chat);
        const uniqConversationDays = uniq(values(FirebaseChatPresenter.conversationDays(chat)));
        const uniqConversationDaysCount = length(uniqConversationDays);
        if (isSentToday) return false;
        return bidsCount < MIN_BIDS || uniqConversationDaysCount < MIN_UNIQ_ACTIVITY_DAYS;
      }, chats);
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/ChatsPresenter.js